import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { translationPropType } from '@eb/i18n';
import { moment } from '@eb/date';

import { START_DATE, END_DATE } from '../constants';

const REF_INPUT_MAP = {
    startDate: '_startDateInput',
    endDate: '_endDateInput',
};

const DateInput = ({
    onFocus,
    classes,
    date,
    placeholder,
    getRef,
    dataSpec,
}) => (
    <div
        className={classes}
        onFocus={onFocus}
        tabIndex={0}
        role="button"
        ref={getRef}
        data-spec={dataSpec}
    >
        {date || placeholder}
    </div>
);

export default class DateRangeInput extends PureComponent {
    static propTypes = {
        onFocus: PropTypes.func.isRequired,
        startDate: PropTypes.string,
        endDate: PropTypes.string,
        startPlaceHolder: translationPropType,
        endPlaceHolder: translationPropType,
        focusedInput: PropTypes.oneOf([START_DATE, END_DATE]),
        inputDelimeter: PropTypes.node,
        inputDisplayFormat: PropTypes.string,
    };

    static defaultProps = {
        inputDelimeter: <span className="eds-l-pad-hor-1">-</span>,
    };

    componentWillReceiveProps({ focusedInput }) {
        if (focusedInput) {
            const refToFocus = REF_INPUT_MAP[focusedInput];

            this[refToFocus].focus();
        }
    }

    _getRef = (refName, ref) => {
        this[refName] = ref;

        return this[refName];
    };

    render() {
        const {
            startDate,
            endDate,
            startPlaceHolder,
            endPlaceHolder,
            onFocus,
            inputDelimeter,
            inputDisplayFormat,
        } = this.props;

        let formattedStartDate;
        let formattedEndDate;

        if (startDate) {
            formattedStartDate = moment(startDate).format(inputDisplayFormat);
        }

        if (endDate) {
            formattedEndDate = moment(endDate).format(inputDisplayFormat);
        }

        return (
            <div className="eds-l-pad-all-2">
                <DateInput
                    classes="eds-date-picker__range-input--start"
                    onFocus={onFocus.bind(null, 'startDate')}
                    date={formattedStartDate}
                    placeholder={startPlaceHolder}
                    getRef={this._getRef.bind(null, '_startDateInput')}
                    dataSpec="eds-date-range-picker__input--start"
                />
                {inputDelimeter}
                <DateInput
                    classes="eds-date-picker__range-input--end"
                    onFocus={onFocus.bind(null, 'endDate')}
                    date={formattedEndDate}
                    placeholder={endPlaceHolder}
                    getRef={this._getRef.bind(null, '_endDateInput')}
                    dataSpec="eds-date-range-picker__input--end"
                />
            </div>
        );
    }
}
